import HeroSection from './components/Hero/HeroSection';
import RentCar from './components/Rent/RentCar';
import PopularBrands from './components/PopularBrands/PopularBrands';
import FeaturedCars from './components/Cars/FeaturedCars';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import AboutUs from './components/AboutUs/AboutUs';
import SuperiorCustomerService from './components/SuperiorCustomerService/SuperiorCustomerService';
import PromoVideo from './components/PromoVideo/PromoVideo';
import TestimonialsSection from './components/Testimonials/TestimonialsSection';
import { useHomeData } from './hooks/useHomeData';

export default function HomePage() {
  const { homeData, loading, error } = useHomeData();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-500 mb-4">Error Loading Data</h2>
          <p className="text-gray-600">Please try refreshing the page</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <HeroSection homeData={homeData} />
      <RentCar />
      <WhyChooseUs />
      <PopularBrands homeData={homeData} />
      <FeaturedCars homeData={homeData} />
      <AboutUs />
      <SuperiorCustomerService />
      <PromoVideo />
      <TestimonialsSection />
    </div>
  );
}
